<style scoped>
.bg-primary {
  background-color: #1a3665 !important;
}
.bg-active {
  background-color: #3e5d92;
}
.bg-subactive {
  background-color: #486ba7;
}
.nav-tabs .nav-link.active, .nav-tabs .nav-item.show .nav-link {
    color: #768192;
    border-color: none; 
    border : none;
    background-color: #486ba7;
}
.button:disabled {
  cursor: no-drop;
}
</style>

<template>
  <div>
    <CCard>
      <CCardHeader
        class="bg-primary text-white border-0 font-weight-bold p-3 d-flex align-items-center">
        Data Peserta RPL
      </CCardHeader>

      <CCardBody>
        <!-- Filter -->       
        <FilterRpl :searchData="searchDataPesertaRpl"/>                 
        <!-- filter -->
        <ul class="nav nav-tabs bg-active border-0 border-bottom-0" id="myTab" role="tablist">            
          <li class="nav-item" ref="tablunas">
            <div
              :class="tab_selected.aria_selected_lunas ? 'nav-link p-3 px-4 font-weight-bold text-white active' : 'nav-link p-3 px-4 font-weight-bold text-white' "
              id="home-tab"
              data-toggle="tab"
              href="#home"
              style="cursor: pointer"
              role="tab"
              aria-controls="home"
              @click="tabchange('lunas')"
              :aria-selected="tab_selected.aria_selected_lunas">
                Lunas
                <span class="badge badge-success text-white">{{ badges.totalLunas }}</span>
              </div>
          </li>
          <li class="nav-item">
            <div
              :class="tab_selected.aria_selected_belum_lunas ? 'nav-link p-3 px-4 font-weight-bold text-white active' : 'nav-link p-3 px-4 font-weight-bold text-white' "
              id="profile"
              data-toggle="tab"
              href="#profile"
              style="cursor: pointer"
              role="tab"
              aria-controls="profile"
              @click="tabchange('belum_lunas')"
              :aria-selected="tab_selected.aria_selected_belum_lunas" >
                Belum Lunas
                <span class="badge badge-danger text-white">{{ badges.totalBelumLunas }}</span>
              </div>
          </li>
          <li class="nav-item">
            <div
              :class="tab_selected.aria_selected_batal ? 'nav-link p-3 px-4 font-weight-bold text-white active' : 'nav-link p-3 px-4 font-weight-bold text-white' "
              id="batal-tab"
              data-toggle="tab"
              @click="tabchange('batal')"
              href="#batal"
              style="cursor: pointer"

              role="tab"
              aria-controls="batal"
              :aria-selected="tab_selected.aria_selected_batal" >
                Lainnya
                <span class="badge badge-warning text-white">{{ badges.totalLainnya }}</span>
              </div>
          </li>
        </ul>
        <CRow>
          <CCol sm="12" md="12" lg="12">
            <CDataTable 
              style="widht: 100% !important"
              :items="items"
              :fields="fields"
              hover
              sorter
            >
              <template #no="{index}">
                <td class="py-2">{{indexed == 0 ? index +1 : index + indexed + 1}}</td>
              </template>
              <template #no_anggota="{item}">
                <td class="py-2">{{item.no_anggota ? item.no_anggota : '-'}}</td>
              </template>

              <template #nama_lengkap="{item}">
                <td
                  class="py-2 text-info"
                  style="cursor: pointer"
                  @click="detailUser(item, index)"
                >
                  {{ item.nama_lengkap ? item.nama_lengkap : '-' }}
                </td>
              </template>

              <template #tanggal_daftar="{item}">
                <td
                  class="py-2 text-center"
                  
                >
                  {{ item.tanggal_daftar }}
                </td>
              </template>

              <template #statusbatal="{ item }">
                <td
                  class="py-2 text-success font-weight-bold"
                  v-if="item.statusbatal == 'Disetujui'"
                >
                  {{ item.statusbatal }}
                </td>
                <td
                  class="py-2 text-danger font-weight-bold"
                  v-else-if="item.statusbatal == 'Ditolak'"
                >
                  {{ item.statusbatal }}
                </td>
                <td
                  class="py-2 text-warning font-weight-bold"
                  v-else-if="item.statusbatal == 'Pengajuan'"
                >
                  {{ item.statusbatal }}
                </td>
                <td class="py-2 text-secondary font-weight-bold" v-else>
                  {{ item.statusbatal }}
                </td>
              </template>              

              <template #aksi="{item}">                
                <td class="py-2 text-center">    
                  <template v-if="role_status && role_status.status_update">              
                  <CButton
                    v-c-tooltip="'Ubah Status Pembatalan'"
                    @click="aksiPembatalan(item)"
                    :disabled="item.statusbatal == 'Tidak Ada Pengajuan' || item.statusbatal == null || item.statusbatal == 'Disetujui'"                  
                    :color="item.statusbatal == 'Tidak Ada Pengajuan' || item.statusbatal == null || item.statusbatal == 'Disetujui' ? 'secondary' : 'info'"
                    class="btn-sm mr-2"
                    square
                  >
                    <i class="fa fa-coins" aria-hidden="true"></i>
                  </CButton>     
                    </template>
                    <template v-else>
                      <CButton
                      v-c-tooltip="'Ubah Status Pembatalan'"
                      disabled                  
                      color="secondary"
                      class="btn-sm mr-2"
                      square
                    >
                      <i class="fa fa-coins" aria-hidden="true"></i>
                    </CButton>
                    </template>
                  <template v-if="role_status && role_status.status_read">
                    <CButton 
                    @click="pindahMataUji(item.id_sertifikasi_rpl_peserta)"
                    v-c-tooltip="'Lihat Mata Uji Peserta'" 
                    class="btn-sm mr-2" 
                    :disabled="item.statusbatal == 'Disetujui'"                  
                    :color="item.statusbatal == 'Disetujui' ? 'secondary' : 'success'"
                    square>
                    <i class="fa fa-eye" aria-hidden="true"></i>
                  </CButton>
                             
                  <CButton 
                    @click="pindahDokumen(item.id_sertifikasi_rpl_peserta)"
                    v-c-tooltip="'Lihat Dokumen Peserta'" 
                    :disabled="item.statusbatal == 'Disetujui'"                  
                    :color="item.statusbatal == 'Disetujui' ? 'secondary' : 'warning'"
                    class="btn-sm text-white" 
                    square>
                    <i class="fa fa-file" aria-hidden="true"></i>
                  </CButton>
                  </template>
                  <template v-else>
                    <CButton 
                    disabled
                    v-c-tooltip="'Lihat Mata Uji Peserta'" 
                    class="btn-sm mr-2"                 
                    color="secondary"
                    square>
                    <i class="fa fa-eye" aria-hidden="true"></i>
                  </CButton>
                             
                  <CButton 
                    disabled
                    v-c-tooltip="'Lihat Dokumen Peserta'" 
                    color="secondary"
                    class="btn-sm text-white" 
                    square>
                    <i class="fa fa-file" aria-hidden="true"></i>
                  </CButton>
                  </template>             
                  
                </td>
              </template>

            </CDataTable>
            <CPagination
              style="float:right"
              :active-page.sync="currentPageDataPesertaRpl"
              :pages="pagination.totalPages"
              responsive
              @click="pageChange"
            />
          </CCol>
        </CRow>        

        <!-- Modal Detail User -->
        <ModalDetailPesertaRpl
          :modalDetail="modalDetail"
          :title="modalTitleDetailUser"
          :formData="formData"
          @closeModalDetail="closeModalDetail($event)"
        />
        <!-- Modal Detail User -->

        <!-- Modal Pengajuan Pembatalan RPL -->
        <ModalPengajuanPembatalanRpl
          :modalDetailPembatalan="modalDetailPembatalan"
          :title="modalTitleDetailPembatalan"
          :formData="formDataPembatalan"       
          @closeModalPembatalan="closeModalPembatalan($event)"   
        />
        <!-- Modal Pengajuan Pembatalan RPL -->
      </CCardBody>
    </CCard>
  </div>
</template>
<script>
import { AlertUtils } from "../../../mixins/AlertUtils";
import { PaginationDataPesertaPesertaRpl } from "../../../mixins/paginationType/PaginationDataPesertaRpl";
import MasterRplService from '../../../services/rpl/master-rpl.service'
import PeriodeRplService from '../../../services/datamaster/periode-rpl.service'
import DataPesertaRplService from '../../../services/rpl/data-peserta-rpl.service';
import FilterRpl from "../../../components/rpl/datapeserta/FilterRpl";
import ModalDetailPesertaRpl from '../../../components/rpl/datapeserta/ModalDetailPesertaRpl'
import ModalPengajuanPembatalanRpl from '../../../components/rpl/datapeserta/ModalPengajuanPembatalanRpl';

const fields = [
  {
    key: "no",
    sorter: true,
    filter: false,    
  },
  {
    key: "nama_rpl",
    label: "Nama Sertifikasi RPL",
    sorter: true,
    filter: false,
  },
  {
    key: "no_anggota",
    label: "No Keanggotaan",
    sorter: true,
    filter: false,
  },  
  {
    key: "nama_lengkap",
    label: "Nama Lengkap",
    sorter: true,
    filter: false,
  },  
  {
    key: "tanggal_daftar",
    label: "Tanggal Pendaftaran",
    _style : "text-align: center",
    sorter: true,
    filter: false,
  },
  {
    key: "statusbatal",
    label: "Status Pembatalan",
    sorter: true,
    filter: false,
  },
  {
    key: "aksi",
    _style: "width:20%; text-align: center",
    sorter: false,
    filter: false,
  },
];

export default {
  name: "data-peserta-rpl",
  mixins: [
    AlertUtils,
    PaginationDataPesertaPesertaRpl
  ],
  components: {
    FilterRpl,    
    ModalDetailPesertaRpl,
    ModalPengajuanPembatalanRpl
  },
  data() {
    return {
      tab_selected : {
        aria_selected_lunas : true,
        aria_selected_belum_lunas : false,
        aria_selected_batal : false
      },
      badges : {
        totalLunas : 0,
        totalBelumLunas : 0,
        totalLainnya : 0
      },
      get_data_status : {
        status_biaya : 'lunas'
      },
      title_tab: "Lunas",
      items: [],                 
      fields,            
      search: "",
      status: false,      
      loading: true,      
      formFilter : {
        periode: '',
        idSertifikasiRpl : '',
      },
      periode: {},
      dataPeriode : [],
      kategoriRpl: {},
      dataKategoriRpl: [],    
      modalDetail: false,
      formData: {},
      formDataPembatalan: {},
      modalDetailPembatalan: false,
      modalTitleDetailPembatalan: "Detail Pembatalan",
      modalTitleDetailUser: "Detail User",
      role_status : null
    };
  },

  watch : {
    'get_data_status.status_biaya' : function (val) {
      this.formFilter.status_pembayaran = val;
    }
  },

  mounted() {
    this.roleData();
    this.getPeriode();
    this.getKategoriRpl();      
    setTimeout(() => {
      this.getData(
        0,
        10,
        "default",
        this.formFilter.idSertifikasiRpl,
        this.formFilter.status_pembayaran,
        this.formFilter.periode
      );
    }, 2000);
  },
  
  methods: {
    roleData()
    {
      var user = JSON.parse(localStorage.getItem('user'));
      var data = user.singleData.detail_user.roles.find(el => el.url === this.$route.path );  
      this.role_status = data;
    },
    pindahDokumen(id) {
      this.$router.push({ path: '/rpl/data-peserta/data-dokumen/'+id })
    },

    pindahMataUji(id) {
      this.$router.push({ path: '/rpl/data-peserta/'+id })
    },

    syncSearch(value) {      
      this.searchDataPesertaRpl = value;
    },

    tabchange(value) {
      switch (value) {
        case 'lunas':
          this.title_tab = 'Lunas';
          this.tab_selected.aria_selected_lunas = true;
          this.tab_selected.aria_selected_belum_lunas = false;
          this.tab_selected.aria_selected_batal = false;
          this.get_data_status.status_biaya = 'lunas';
          this.getData(
            0, 
            10, 
            "default", 
            this.formFilter.idSertifikasiRpl, 
            this.formFilter.status_pembayaran,
            this.formFilter.periode, 
          );      
          this.getCountLunas()
          this.getCountBelumLunas()
          this.getCountLainnya()
          break;
        case 'belum_lunas':
          this.title_tab = 'Belum Lunas';
          this.tab_selected.aria_selected_lunas = false;
          this.tab_selected.aria_selected_belum_lunas = true;
          this.tab_selected.aria_selected_batal = false
          this.get_data_status.status_biaya = 'belum_lunas'                  
          this.getData(
            0, 
            10, 
            "default", 
            this.formFilter.idSertifikasiRpl, 
            this.formFilter.status_pembayaran,
            this.formFilter.periode, 
          );  
          this.getCountLunas()
          this.getCountBelumLunas()
          this.getCountLainnya()  
          break;
        case 'batal':
          this.title_tab = 'Batal';
          this.tab_selected.aria_selected_lunas = false;
          this.tab_selected.aria_selected_belum_lunas = false;
          this.tab_selected.aria_selected_batal = true;
          this.get_data_status.status_biaya = 'batal'          
          this.getData(
            0, 
            10, 
            "default", 
            this.formFilter.idSertifikasiRpl, 
            this.formFilter.status_pembayaran,
            this.formFilter.periode, 
          );  
          this.getCountLunas()
          this.getCountBelumLunas()
          this.getCountLainnya()
          break;
        default:
          break;
      }
    },

    getCountLunas() {
      DataPesertaRplService.getDataPeserta(
        0,
        10,
        "default",
        this.formFilter.idSertifikasiRpl,
        'lunas',
        this.formFilter.periode
      )
        .then((response) => {
          this.badges.totalLunas = response.data.data.totalElements;
        })
        .catch((error) => {
          // comment console console.log(error);
        });
    },

    getCountBelumLunas() {
      DataPesertaRplService.getDataPeserta(
        0,
        1,
        "default",
        this.formFilter.idSertifikasiRpl,
        'belum_lunas',
        this.formFilter.periode
      )
        .then((response) => {
          this.badges.totalBelumLunas = response.data.data.totalElements;
        })
        .catch((error) => {
          // comment console console.log(error);
        });
    },

    getCountLainnya() {
      DataPesertaRplService.getDataPeserta(
        0,
        10,
        "default",
        this.formFilter.idSertifikasiRpl,
        'batal',
        this.formFilter.periode
      )
        .then((response) => {
          this.badges.totalLainnya = response.data.data.totalElements;
        })
        .catch((error) => {
          // comment console console.log(error);
        });
    },    

    filterData(formFilter) {
      this.formFilter = formFilter;
      this.getData(
        0,
        10,
        "default",
        this.formFilter.idSertifikasiRpl,
        this.formFilter.status_pembayaran,
        this.formFilter.periode
      );
      this.getCountLunas();
      this.getCountBelumLunas();
      this.getCountLainnya();
    },

    postStatusPembatalan() {          
      let loader = this.$loading.show({
        container: false ? null : this.$refs.formContainer,
        canCancel: true,
        onCancel: this.onCancel,
      });      

      let vm = this;

      let status = this.formDataPembatalan.statusbatal === "Disetujui" ? '1' : '2';      

      let data = {
        id_sertifikasi_rpl_peserta: this.formDataPembatalan.id_sertifikasi_rpl_peserta,
        status_pembatalan: status
      };

      DataPesertaRplService.putStatusPembatalan(data)
        .then((response) => {
          loader.hide();
          this.modalDetailPembatalan = false;
          this.alertEditSuccess();
          this.getData(
            this.currentPage - 1, 
            this.pageSize,
            this.search, 
            this.formFilter.idSertifikasiRpl, 
            this.formFilter.status_pembayaran,
            this.formFilter.periode, 
          );            
        })
        .catch((error) => {
          // comment console console.log(error);
          this.alertError();
        });  
    },

    getPeriode() {
      this.loading = true;
      PeriodeRplService.getPeriodeSelect()
        .then(response => {
          this.dataPeriode = response.data.data
          this.periode = this.dataPeriode.find(el => el.status === "1");      
          this.formFilter.periode = this.periode.value; 
          this.loading = false;             
        })
        .catch(error => {
          this.loading = false;
          // comment console console.log(error)
        })      
    },

    aksiPembatalan(item) { 
      this.modalDetailPembatalan = true;
      this.formDataPembatalan = item;
      // comment console console.log(this.formDataPembatalan)
    },   

    closeModalPembatalan(val) {      
      if(val === false) {
        this.modalDetailPembatalan = false
      }      
    },

    closeModalDetail(val) {
      if(val === false) {
        this.modalDetail = false;
      }
    },

    pilihStatusPembayaran(e) {            
      this.formFilter.status_pembayaran = e.target.value;      
      this.getData(
        "0",
        this.pageSize,
        this.searchDataPesertaRpl,
        this.formFilter.idSertifikasiRpl,
        this.formFilter.status_pembayaran,
        this.formFilter.periode,
      );
    },

    pageChange() {
      this.getData(currentPage)
    },      

    getData(
      currentPage, 
      pageSize, 
      search,
      idSertifikasiRpl,
      statusPembayaran, 
      periode      
    ) {
      let loader = this.$loading.show({
        container: false ? null : this.$refs.formContainer,
        canCancel: true,
        onCancel: this.onCancel,
      });

      var vm = this;

      var status_pembayaran = this.get_data_status.status_biaya;

      DataPesertaRplService.getDataPeserta(
        currentPage, 
        pageSize, 
        search, 
        idSertifikasiRpl,
        status_pembayaran, 
        periode,         
      )
        .then(response => {
          loader.hide();
          vm.items = response.data.data.content;
          vm.pagination.totalPages = response.data.data.totalPages;
          vm.currentPageDataPesertaRpl = response.data.data.pageable.pageNumber + 1;
        })
        .catch(error => {
          loader.hide();
          // comment console console.log(error)
        })
    },        

    detailUser(item, index) {
      this.modalDetail = true;
      this.formData = item;
    },
    
    getKategoriRpl() {
      this.loading = true;
      DataPesertaRplService.getKategoriPesertaRpl()              
        .then(response => {          
          this.dataKategoriRpl = response.data.data;
          this.kategoriRpl = this.dataKategoriRpl[0]
          this.formFilter.idSertifikasiRpl = this.kategoriRpl.id_sertifikasi_rpl;
          this.loading = false;          
        })
        .catch(error => {
          this.loading = false;
          // comment console console.log(error)
        })
    },
    
    changePeriode(e) {      
      this.formFilter.periode = e.value
    },

    changeKategoriRpl(value) {      
      this.modalDetailPembatalan = false;
      this.formFilter.idSertifikasiRpl = value.id_sertifikasi_rpl      
      this.getData(
        this.currentPage - 1,
        this.pageSize,
        this.get_data_status.status_biaya,
        this.formFilter.idSertifikasiRpl,
        "default"
      );
      this.$parent.changeKategoriRpl(value);      
    },          

    resetFilter() {
      this.periode = '';
      this.kategoriRpl = '';
      this.formFilter.periode = this.dataPeriode.filter(el => el.status === "1")      
    },         
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
